module.exports = __webpack_public_path__ + "img/PantallaPromo-01.96f13c16.svg";